import { envs } from './envs';

export const navigateToMobilePage = (route: string, title?: string): void => {
  if ((window as any)?.AppActions?.openGenericPage) {
    const pageTitle = title || '';
    const [basePath, queryString] = route.split('?');
    const queryParams = new URLSearchParams(queryString || '');
    queryParams.set('mobile', 'true');
    const newRoute = queryString
      ? `${envs.REACT_APP_FRONTEND_URL}${basePath}?${queryParams.toString()}`
      : `${envs.REACT_APP_FRONTEND_URL}${basePath}?mobile`;

    (window as any).AppActions.openGenericPage(newRoute, pageTitle);
  } else {
    console.warn('AppActions.openGenericPage is not available. Standard navigation might be required.');
  }
};

export const tabNavigation = ({path, account})=> {
  if ((window as any)?.AppActions?.switchTab && path) {
    (window as any).AppActions.switchTab(path, account?.id ?
      {
        actionType: 'openGenericPage',
        actionPayload: {
          url: `${envs.REACT_APP_FRONTEND_URL}/dashboard/chat?mobile&chatId=${account?.chat?.id}`,
          title: `${account?.given_name} ${account?.family_name}`,
          appBarActions: [
            {
              imgUrl: `${envs.REACT_APP_S3_ENDPOINT}/pic-${account?.chat?.therapistId}?t=${Date.now()}`,
              actionType: "openGenericPage",
              iconStyle: {
                shape: "circle"
              },
              actionPayload: {
                url: `${envs.REACT_APP_FRONTEND_URL}/dashboard/chat?mobile&chatId=${account?.chat?.id}&therapistInfo`,
                title: `${account?.given_name} ${account?.family_name}`
              }
            }
          ]
        },
        delay: 1500
      } : null)
  }
}
